import { NotificationEventData } from "@/types/socket"

export class NotificationManager {
  static _instance: NotificationManager | undefined
  private subscribers = new Set<NotificationEventSubscriber>()

  private constructor() {
    // singleton
  }

  static get instance() {
    if (!this._instance) {
      this._instance = new NotificationManager()
    }
    return this._instance
  }

  emit(data: NotificationEventData) {
    this.subscribers.forEach((subscriber) => subscriber(data))
  }

  addSubscriber(callback: NotificationEventSubscriber) {
    this.subscribers.add(callback)
  }

  removeSubscriber(callback: NotificationEventSubscriber) {
    this.subscribers.delete(callback)
  }
}

type NotificationEventSubscriber = (data: NotificationEventData) => void
